import { ConfigurationState } from "@/static/Configuration"
import { useAuthenticationStore } from "@/stores/authentication"

export default () => {
  const auth = useAuthenticationStore()
  // Si pas de compte, considérer comme configuré
  const isConfigured = auth.user?.account?.configured ?? true
  const state = auth.user?.account?.configuration_state

  if (!isConfigured) {
    // Les comptes DEMO ne sont pas configurés mais ne doivent pas être redirigés par le middleware
    // La redirection initiale se fait uniquement lors de la connexion via magic link
    if (state === ConfigurationState.DEMO) {
      return {
        success: true,
      }
    }

    return {
      success: false,
      path: "/configuration",
    }
  }
  return {
    success: true,
  }
}
